import allowResponseForSmimeItem from '../utils/allowResponseForSmimeItem';
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { ActionSource } from 'owa-analytics-actions';
import { ClientItemId } from 'owa-client-ids';
import loc, { format } from 'owa-localize';
import { irm_actionNotAllowedOnThisItem } from 'owa-locstrings/lib/strings/irm_actionnotallowedonthisitem.locstring.json';
import { itemHeaderReply } from 'owa-locstrings/lib/strings/itemheaderreply.locstring.json';
import { itemHeaderReplyAll } from 'owa-locstrings/lib/strings/itemheaderreplyall.locstring.json';
import { lazyReplyToMessage } from 'owa-mail-compose-actions';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { mailStore, ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import isSMIMEItem from 'owa-smime/lib/utils/isSMIMEItem';
import { action } from 'satcheljs/lib/legacy';
import { isFeatureEnabled } from 'owa-feature-flags';

export default action('replyToItem')(async function replyToItem(
    itemId: ClientItemId,
    isReplyAll: boolean,
    actionSource: ActionSource,
    instrumentationContexts: InstrumentationContext[],
    suppressServerMarkReadOnReplyOrForward: boolean,
    targetWindow?: Window
) {
    const restrictionToConfirm = <IRMRestrictions>{
        ReplyAllAllowed: isReplyAll,
        ReplyAllowed: !isReplyAll,
    };
    const itemActionString = isReplyAll ? loc(itemHeaderReplyAll) : loc(itemHeaderReply);
    const item: ClientItem = mailStore.items.get(itemId.Id);
    const isResponseAllowedForSmimeItem =
        !isSMIMEItem(item) || (await allowResponseForSmimeItem(itemId.Id, itemActionString));

    // useFullcompose needs to be evaluated depending on whether the item is translated or not.
    let useFullCompose = true;
    let conversationId: string = undefined;

    if (
        isFeatureEnabled('cmp-inlineTranslation') &&
        item &&
        item.TranslationData &&
        (item.TranslationData.isShowingTranslation ||
            item.TranslationData.isShowingForwardContentTranslation)
    ) {
        useFullCompose = false;
        conversationId = item.ConversationId ? item.ConversationId.Id : null;
    }

    if (
        confirmItemActionAllowed(
            itemId.Id,
            restrictionToConfirm,
            format(loc(irm_actionNotAllowedOnThisItem), itemActionString)
        ) &&
        isResponseAllowedForSmimeItem
    ) {
        lazyReplyToMessage.importAndExecute({
            referenceItemId: itemId,
            isReplyAll: isReplyAll,
            conversationId: conversationId,
            useFullCompose: useFullCompose,
            actionSource: actionSource,
            instrumentationContexts: instrumentationContexts,
            suppressServerMarkReadOnReplyOrForward: suppressServerMarkReadOnReplyOrForward,
            targetWindow: targetWindow,
        });

        mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
    }
});
